import { useState } from "react";
import { Box } from "@mui/material";
import EmployeeMetrics from "./EmployeeMetrics";
import EmployeeCharts from "./EmployeeCharts";
import EmployeePerformanceTable from "./EmployeePerformanceTable";
import EmployeeProfile from "./EmployeeProfile";

const EmployeeReports = ({ onDetailedViewChange, dateRange }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [viewMode, setViewMode] = useState("dashboard"); // dashboard, profile

  const handleViewProfile = (employee) => {
    setSelectedEmployee(employee);
    setViewMode("profile");
    if (onDetailedViewChange) {
      onDetailedViewChange(true);
    }
  };

  const handleBackFromProfile = () => {
    setSelectedEmployee(null);
    setViewMode("dashboard");
    if (onDetailedViewChange) {
      onDetailedViewChange(false);
    }
  };

  // Show employee profile if selected
  if (viewMode === "profile" && selectedEmployee) {
    return <EmployeeProfile employee={selectedEmployee} onBack={handleBackFromProfile} />;
  }

  return (
    <Box>
      {/* Top Metrics */}
      <Box sx={{ mb: 4 }}>
        <EmployeeMetrics dateRange={dateRange} />
      </Box>

      {/* Charts Section */}
      <Box sx={{ mb: 4 }}>
        <EmployeeCharts dateRange={dateRange} />
      </Box>

      {/* Detailed Employee Performance */}
      <EmployeePerformanceTable onViewProfile={handleViewProfile} dateRange={dateRange} />
    </Box>
  );
};

export default EmployeeReports;
